export class spoTemplate{
    id: string = ""
    name: string = ""
    title: string = ""
    description: string = ""
}

